"use client";

/**
 * Globalny rejestr „query loaded" — śledzi które realtime queries dostały
 * już swój pierwszy snapshot. Używany przez DataPrefetcher do wyznaczenia
 * momentu w którym aplikacja może opuścić splash screen.
 *
 * Każdy hook woła `markReady(key)` w callback onSnapshot pierwszego razu.
 * Listenery (np. `useAllReady(keys)`) są powiadamiane o zmianach.
 */

const ready = new Set<string>();
const listeners = new Set<() => void>();

export function markReady(key: string): void {
  if (ready.has(key)) return;
  ready.add(key);
  listeners.forEach((l) => l());
}

export function isReady(key: string): boolean {
  return ready.has(key);
}

export function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getReadySnapshot(keys: readonly string[]): boolean {
  return keys.every((k) => ready.has(k));
}

/** Reset całego rejestru — przy wylogowaniu lub zmianie household. */
export function resetRegistry(): void {
  ready.clear();
  listeners.forEach((l) => l());
}
